export const tipoHistoricoNome = (tipoHistorico) => {
  switch (tipoHistorico) {
    case 'COMPRA':
      return 'Compra';
    case 'MANUTENCAO':
      return 'Manutenção';
    case 'REPASSE':
      return 'Repasse';
    case 'VENDA_TROCA':
      return 'Venda/Troca';
    case 'SUCATA':
      return 'Sucata';
    default:
      return tipoHistorico;
  }
};

export const ordernarPorDataHistorico = (a, b) =>
  b.dataHistorico.localeCompare(a.dataHistorico);

export const buildEquipamentoFilter = (filterData) => {
  const { codigo, modelos, modelo, ...rest } = filterData;
  const modelosList = Array.isArray(modelos) && modelos.length
    ? modelos
    : (modelo || codigo ? [modelo || codigo] : null);
  return {
    ...rest,
    modelos: modelosList,
  };
};

/** Filtros que pedem unidade individual → lista flat paginada. */
export const isFiltroIdentidade = (filter) => Boolean(
  filter?.numPatrimonio
  || filter?.numSerie
  || filter?.colaborador
  || filter?.sisant,
);

export const grupoEquipamentoId = (row) =>
  `${row.tipoEquipamento || ''}::${row.modelo || ''}`;

/** Contagens do grouped: com Eletropontes vs com colaborador. */
export const getPosseContagens = (row) => {
  const comEmpresa = Number(row?.contagemComEletropontes ?? 0);
  const comColaborador = Number(row?.contagemComColaborador ?? 0);
  return { comEmpresa, comColaborador };
};

/**
 * Posse atual da unidade.
 * Prefere `posseEletropontes` do BE; senão deriva de `ultimoRepasse`
 * (ex.: "Devolução - Está com Eletropontes" / "Entrega - Nome").
 * Sem repasse → com a empresa (mesma regra do filtro BE).
 */
export const isUnidadeComEletropontes = (unidade) => {
  if (typeof unidade?.posseEletropontes === 'boolean') {
    return unidade.posseEletropontes;
  }
  const repasse = String(unidade?.ultimoRepasse || '').trim();
  if (!repasse || repasse === '—') {
    return true;
  }
  if (/eletropontes/i.test(repasse)) {
    return true;
  }
  if (/^entrega\b/i.test(repasse)) {
    return false;
  }
  if (/^devolu[cç][aã]o\b/i.test(repasse)) {
    return true;
  }
  return true;
};

/**
 * @param {Array} unidades
 * @param {boolean|null} comEletropontes — null = todas
 */
export const filterUnidadesByPosse = (unidades, comEletropontes) => {
  const list = unidades || [];
  if (comEletropontes == null) return list;
  return list.filter((u) => isUnidadeComEletropontes(u) === comEletropontes);
};
